import moment from 'moment-timezone';

export const formatDate = (raw) => {
  return moment(raw).format('YYYY-MM-DD');
};
